import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import globals from '#utilities/js/ea/globals.js'

export default async (url, objects, elem) => {
  const [promise, { resolve, reject }] = resolvable()
  const { window } = defaults
  const { FormData, XMLHttpRequest } = window
  const fd = new FormData()
  for (const obj of objects) {
    const { blob, file } = obj
    const { name } = file
    fd.append("upload[]", blob, name)
  }
  const request = new XMLHttpRequest();
  request.open('POST', url);
  request.upload.onprogress = (e) => {
    if (!e.lengthComputable||!e.total)
      return
	const { loaded, total } = e
    const percent = loaded / total
    if (elem) {
      elem.value = percent * 100
    }
  }
  request.onreadystatechange = () => {
    const { readyState } = request
    if (readyState === 4) {
      if (elem) {
        remove(elem)
      }
	  const { responseText } = request
	  resolve(responseText)
    }
  }
  request.onerror = (e) => {
    reject(e)
  }

  request.send(fd)
  return promise
}
